import { Component, Vue, Prop, Emit, Inject } from 'vue-property-decorator';
import type { IBriefingPage, IResourceModel, UserProfileInfo } from '@/shared/model/briefing-widget.model';
import GoCardFooterVer2 from '@/shared/cards/footer/go-card-footer-v2.vue';
import { namespace } from 'vuex-class';
import DiscoveryAndReportService from '@/service/discoveryAndReport.service';
import { isNullOrEmptyString } from '@/util/string.util';
import { isNullOrEmptyArray } from '@/util/array-util';
import BriefingService from '@/service/briefing.service';
import { innitNtfSummaryDetails } from '@/shared/cards/briefing/public-notification-summary-widget/public-notification-summary-widget.component';

const briefingStore = namespace('briefingStore');
// const homeStore = namespace('homeStore');
@Component({
  components: {
    'go-card-footer-v2': GoCardFooterVer2,
  },
  computed: {
    isContentNew() {
      return this.formModel && this.formModel.isNew;
    },
  },
})
export default class GoCardCompanyVer2 extends Vue {
  @Prop(Object) readonly formModel: IResourceModel;
  @Prop(Boolean) readonly showFooterActions: boolean | true;
  @Prop(Object) readonly companyBpDetail: IBriefingPage | undefined;
  @Prop(Boolean) readonly isHideOptions: boolean;
  @Prop(Boolean) readonly isHideHidden: boolean;
  @Prop(Boolean) readonly isHideGoover: boolean;
  @Prop(Boolean) readonly isHideShared: boolean;
  @Prop(Boolean) readonly isHideAddReference: boolean | false;

  @Inject('discoveryService')
  public discoveryService: () => DiscoveryAndReportService;

  @Inject('briefingService')
  private briefingService: () => BriefingService;

  @briefingStore.Getter
  public getCompanyWidgetDetail!: any;

  @briefingStore.Getter
  public getFeaturedCompanies!: IResourceModel[];

  @briefingStore.Getter
  public getTotalSubscribeCompany!: number;

  @briefingStore.Mutation
  public setCompanyPages: (payload: IBriefingPage[]) => void;

  @briefingStore.Getter
  public getCompanyPages!: IBriefingPage[];

  @briefingStore.Mutation
  public setTotalSubscribeCompany: (payload: number) => void;

  @briefingStore.Mutation
  public setFeaturedCompanies: (payload: IResourceModel[]) => void;

  // @homeStore.Mutation
  @briefingStore.Mutation
  public setCompanyWidgetDetail: (payload: any) => void;

  @briefingStore.Mutation
  public setCompanyBpDetail!: (payload: any) => void; // New mutation name

  @briefingStore.Mutation
  public setIsCloseCompanyBpDetail!: (payload: boolean) => void;

  private reportInfo: IResourceModel;
  isIncrease: boolean;
  private companyBpId: string;
  subWidgetContent = '';
  stckSentimentIdx: string;
  publicInfoSentimentIdx: string;
  socialSentimentIdx: string;
  avatar;
  reportImage;
  // private isCompanyCard = false;
  isLoadingSubcribe = false;
  // private isSubscribed = false;
  buzzBuzzSummaryDataDetail = [];
  buzzBuzzDetail = [];
  companyBp: IBriefingPage = {} as IBriefingPage;
  userProfile: UserProfileInfo = null;
  briefingPage: IBriefingPage;

  created() {
    // this.avatar = 'https://dzh91b51qfr7r.cloudfront.net/company/thumbnail/' + this.formModel?.thumbnail;
    this.avatar = this.formModel?.thumbnail;
    this.reportImage = this.formModel?.other_info?.insightReportImg;
    this.isIncrease = this.formModel?.other_info?.stckFlctsrt?.includes('+');
    this.companyBpId = this.formModel?.cmp_bp_id;
    this.stckSentimentIdx = this.formModel?.other_info?.stckSentimentIdx?.toLowerCase();
    this.socialSentimentIdx = this.formModel?.other_info?.socialSentimentIdx?.toLowerCase();
    this.publicInfoSentimentIdx = this.formModel?.other_info?.publicInfoSentimentIdx?.toLowerCase();
    // this.isCompanyCard = this.formModel?.type === 'COMPANY';
    this.setIsCloseCompanyBpDetail(false);
  }

  mounted() {
    if (!isNullOrEmptyArray(this.formModel?.other_info?.subWidgetContent?.stockChatsSummarys)) {
      // this.subWidgetContent = this.formModel?.other_info?.subWidgetContent?.stockChatsSummarys[0]?.summaryContent;
    } else if (!isNullOrEmptyArray(this.formModel?.other_info?.subWidgetContent?.summarys)) {
      // this.subWidgetContent = this.formModel?.other_info?.subWidgetContent?.summarys[0]?.summaryContent;
    }

    if (!this.reportImage) {
      this.setDefaultReportImage();
    }
  }

  private imagePath = '@/../content/images/';
  // private companyDefaultImg = this.imagePath + 'icon-organization_back.png';
  private companyDefaultImg = this.imagePath + 'profile.png';
  private companyDefaultReportImg = this.imagePath + '@landscape.jpg';

  setDefaultImage() {
    this.avatar = this.companyDefaultImg;
    this.$forceUpdate();
  }

  setDefaultReportImage() {
    this.reportImage = this.companyDefaultReportImg;
    this.$forceUpdate();
  }

  // saveToResource(isResource: boolean) {
  //   this.$emit("toggleResource", this.formModel, this.key);
  // }

  @Emit('toggle-resource') saveToResource() {}

  @Emit('share') share() {}

  @Emit('hide') hide() {}

  // @Emit('view-detail') viewDetail() {}
  viewDetail() {
    const url = this.$router.resolve({
      path: `/my-briefing/company/${this.companyBpId}`,
      query: { reload: Date.now().toString() },
    }).href;

    window.open(url, '_blank');
  }

  @Emit('view-detail-report') viewDetailReport() {
    this.reportInfo = {
      _id: this.formModel?.other_info?.insightReportId,
      docId: this.formModel?.other_info?.insightReportId,
      type: 'REPORT',
      mediaType: 'REPORT',
    };
    return this.reportInfo;
  }

  notificationSummaryDataDetail = [];
  ntfSummaryDetail: any = innitNtfSummaryDetails;
  async getDataDetail() {
    this.setIsCloseCompanyBpDetail(false);
    const buzzbuzzDetail = this.formModel?.other_info?.subWidgetContent?.stockChatsSummarys
      ? this.formModel?.other_info?.subWidgetContent?.stockChatsSummarys[0]
      : null;
    const ntfSummaryDetail = this.formModel?.other_info?.subWidgetContent?.summarys
      ? this.formModel?.other_info?.subWidgetContent?.summarys[0]
      : null;
    if (buzzbuzzDetail) {
      const parentDocId = this.formModel?.other_info?.subWidgetContent?.stockChatsSummarys[0].docId;
      await this.discoveryService()
        .getDetailService(parentDocId)
        .then(res => {
          if (res?.data) {
            this.buzzBuzzSummaryDataDetail = res.data;
            this.buzzBuzzDetail = JSON.parse(res?.data?.serviceHtml);
          }
        });
      this.setCompanyWidgetDetail({
        name: 'BuzzBuzzSummaryDetail',
        widgetData: {
          companyBpName: this.formModel?.other_info?.cmpNm || '',
          companyBpId: this.formModel.bpId,
          userProfile: null,
          buzzBuzzDetail: this.buzzBuzzDetail,
          buzzBuzzSummaryDataDetail: this.buzzBuzzSummaryDataDetail,
        },
      });
    }
    if (ntfSummaryDetail) {
      const parentDocId = this.formModel?.other_info?.subWidgetContent?.summarys[0].docId;
      await this.discoveryService()
        .getDetailService(parentDocId)
        .then(res => {
          if (res?.data) {
            this.notificationSummaryDataDetail = res.data;
            this.ntfSummaryDetail = JSON.parse(res?.data?.serviceHtml);
          } else {
            this.ntfSummaryDetail = innitNtfSummaryDetails;
          }
        });
      this.setCompanyWidgetDetail({
        name: 'PublicNotificationSummaryDetail',
        widgetData: {
          companyBpName: this.formModel?.other_info?.cmpNm || '',
          companyBpId: this.formModel.bpId,
          userProfile: null,
          ntfSummaryDetail: this.ntfSummaryDetail || null,
          notificationSummaryDataDetail: this.notificationSummaryDataDetail || null,
        },
      });
    }
    await this.showCompanyBriefing(this.formModel?.cmp_bp_id);
  }

  navigateToCompanyBriefingPage() {
    this.$router.push('/my-briefing/social/' + this.formModel.cmp_bp_id);
  }

  async showCompanyBriefing(companyBpId: string) {
    this.briefingService()
      .getAllCompanyBriefingPage(
        this.$store.getters?.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id,
        companyBpId,
        undefined,
        undefined,
        false
      )
      .then(res => {
        const isDataAndBriefingPageListExist = res?.data?.body?.briefingPageList && res.data.body.briefingPageList.length > -1;
        if (isDataAndBriefingPageListExist) {
          this.companyBp = res.data.body.briefingPageList[0];
          this.setCompanyBpDetail(this.companyBp); // Set data using Vuex mutation
        } else {
          console.warn('No data found in briefingPageList');
        }
      })
      .catch(err => {
        console.error('Error fetching company briefing data:', err);
      });
  }

  subscribeToCompany() {
    if (!this.formModel) return;

    this.isLoadingSubcribe = true;
    const { subscribeStatus, cmp_bp_id, countSubscribe } = this.formModel;
    const isCurrentlySubscribed = subscribeStatus === 'SUBSCRIBE';
    const newStatus = isCurrentlySubscribed ? 'UN_SUBSCRIBE' : 'SUBSCRIBE';
    const updatedSubscribeCount = countSubscribe + (isCurrentlySubscribed ? -1 : 1);

    if (!cmp_bp_id) return;
    this.briefingService()
      .getBriefingInfo(cmp_bp_id) // Fetch briefing info before updating status
      .then(() => {
        return this.briefingService().updateSubscribeBriefingPage(this.companyBpId, newStatus);
      })
      .then(() => {
        this.updateStoreWithBriefingPage(newStatus, updatedSubscribeCount);
      })
      .catch(error => console.error('Error updating subscription status:', error))
      .finally(() => {
        this.isLoadingSubcribe = false;
      });
  }

  private updateStoreWithBriefingPage(newStatus: string, subscribeCount: number) {
    this.formModel.subscribeStatus = newStatus;
    this.formModel.countSubscribe = subscribeCount;

    if (newStatus === 'SUBSCRIBE') {
      const featuredIndex = this.getFeaturedCompanies.findIndex(e => {
        if (this.$route.name === 'CompanyBriefing-All') {
          return e.cmp_bp_id.toLowerCase() === this.formModel.cmp_bp_id.toLowerCase();
        } else {
          return e.bpId.toLowerCase() === this.formModel.cmp_bp_id.toLowerCase();
        }
      });
      if (featuredIndex >= 0) {
        this.getFeaturedCompanies.splice(featuredIndex, 1);
        this.setTotalSubscribeCompany(this.getTotalSubscribeCompany + 1);
      }
      this.getCompanyPages.unshift({ ...this.briefingPage, subscribeStatus: newStatus, subscribeCount });
    } else {
      const socialIndex = this.getCompanyPages.findIndex(e => e.bpId.toLowerCase() === this.briefingPage.bpId.toLowerCase());
      if (socialIndex >= 0) {
        this.getCompanyPages.splice(socialIndex, 1);
        this.setTotalSubscribeCompany(this.getTotalSubscribeCompany - 1);
      }
    }
    // console.log('this.getTotalSubscribeCompany: ', this.getTotalSubscribeCompany);
    this.setFeaturedCompanies(this.getFeaturedCompanies);
    this.setCompanyPages(this.getCompanyPages);
  }
}
